<template>
  <div class="overflow-hidden vh-100 overflow-y-hidden">
    <Header :activeTab="activeTab" />
    <Tabs
      :parvandehModalState="parvandehModalState"
      @getActiveTab="getActiveTab"
    />
    <Content
      v-if="activeTab"
      :activeTab="activeTab"
      :loading="loading"
      :items="items"
    />
  </div>
</template>

<script>
import Header from "./components/Header";
import Tabs from "./components/Tabs";
import Content from "./components/Content";
import { provide, ref } from "vue";
export default {
  components: {
    Header,
    Tabs,
    Content,
  },
  setup() {
    const activeTab = ref(null);
    const getActiveTab = (data) => {
      activeTab.value = data;
    };

    const loading = ref(false);
    const updateLoading = (value) => (loading.value = value);
    const items = ref([]);
    const updateItems = (data) => (items.value = [...data]);
    // generate provide data to child components
    provide("getLoading", updateLoading);
    provide("getItems", updateItems);

    const parvandehModalState = ref(false);
    const updateCloseParvandehModel = (value) =>
      (parvandehModalState.value = value);
    provide("updateCloseParvandehModel", updateCloseParvandehModel);

    // return data to be used in template
    return {
      activeTab,
      getActiveTab,
      loading,
      items,
      updateItems,
      parvandehModalState,
    };
  },
};
</script>
